import en from'./en'
import pt from './pt'

export default {
	'pt': pt, 
	'en': en
}